import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/card-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/card-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/card-profiles/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/card-profiles/${data.card_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient.delete(`/api/card-profiles/${id}`).then(response => Promise.resolve(response.data))
}

export const getCustomer = (Options = {}) => {
  return httpClient
    .get('/api/card-profiles/customers', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getCardType = (Options = {}) => {
  return httpClient
    .get('/api/card-profiles/card-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getCardStatus = (Options = {}) => {
  return httpClient
    .get('/api/card-profiles/card-status', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const statusChange = data => {
  return httpClient
    .post(`/api/card-profiles/${data.card_id}/change-status`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  find,
  update,
  getCustomer,
  getCardType,
  getCardStatus,
  statusChange
}
